import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { myTemplatesQueryOptions } from '../../../-hooks/useMyTemplatesQuery';

export const Route = createFileRoute(
  '/(client)/questionnaires/(pages)/(list)/templates/',
)({
  loader: () =>
    queryClient.ensureQueryData(
      myTemplatesQueryOptions({ page: 1, count: 50 }),
    ),
  component: lazyRouteComponent(
    () => import('../../../-components/TemplatesTab'),
    'TemplatesTab',
  ),
});
